export const paths = {
  home: "/",
  auth: {
    signIn: "/auth/sign-in",
    signUp: "/auth/sign-up",
    resetPassword: "/auth/reset-password",
  },
  console: {
    index: `/console`,
    analysis: `/console/analysis`,
    dashboard: "/console/dashboard",
    screener: "/console/screener",
    copilot: "/console/copilot",
    settings: "/console/settings",
  },
  checkout: `/checkout`,
} as const;

const defaultCode = "AAPL.NASDAQ";
const defaultName = "Apple Inc.";
export const defaultInitialPath =
  paths.console.analysis + `/${defaultCode}?stockName=${defaultName}`;
